import Lookup from 'src/componentes/select2';

const Idioma = ({ ...rest }) => {
  const lookupRenderDescricao = ({ data }) => {
    return (
      <div>
        <img
          src={`/bandeiras/${data.icone}`}
          style={{ width: 16, height: 16, marginRight: 8 }}
        />
        <span>{data.descricao}</span>
      </div>
    );
  };

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/IdiomaLookup"
      valueComponent={lookupRenderDescricao}
      {...rest}
    />
  );
};

export default Idioma;
